// eslint-disable-next-line import/no-anonymous-default-export
export default {
  backendUrl: "https://backend.combinedarms.co.uk:8443",
  poll_refresh_timer_in_minutes: 30,
  poll_event_timer_in_seconds: 15,
  max_poll_refresh_amount: 60, //5 minutes
  cognito: {
    REGION: "eu-west-2",
    USER_POOL_ID: "eu-west-2_afV0mwJrC",
    APP_CLIENT_ID: "3d1i2evvveghpff0kq8u35hoe2",
    IDENTITY_POOL_ID: "eu-west-2:c75fc30c-5570-4f4c-8255-fa973c55e844",
  },
  repos: {
    MAIN: "http://mods.combinedarms.co.uk/main",
    VANILLAPLUS: "http://mods.combinedarms.co.uk/core",
    SPECIAL: "http://mods.combinedarms.co.uk/special",
    JOINT: "http://mods.combinedarms.co.uk/joint",
    WW2: "http://mods.combinedarms.co.uk/ww2",
  },
};
